import React from 'react';
import { motion } from 'framer-motion';
import "@fontsource/libre-barcode-39";
import '../css/Home.css';
import { 
  FaYoutube, 
  FaXTwitter, 
  FaLinkedin, 
  FaInstagram, 
  FaFacebook, 
  FaAtom, 
  FaEnvelope, 
  FaGlobe 
} from 'react-icons/fa6';

function Home() {
  return (
    <div className="home-root">
      <div className="glow-orb top-left"></div>
      <div className="glow-orb bottom-right"></div>
      
      <main className="main-content">
        {/* Centered Single Column Profile Card */}
        <motion.div 
          className="dashboard-card single-column"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <div className="dashboard-profile-section">
            <div className="profile-photo-wrapper">
              <img src="/logo.png" className="profile-photo" alt="Devika Thilothamma" />
            </div>
            
            <div className="profile-identity">
              <h1 className="profile-name">Devika Thilothamma</h1>
              <div className="profile-title-tag">
                <FaAtom className="title-icon spin-slow" />
                <span>CHEMISTRY</span>
              </div>
              <p className="profile-subtitle">From Molecules to Innovation</p>
            </div>
            
            <div className="profile-actions">
              <a 
                href="mailto:devika@xchip.in" 
                className="btn btn-primary"
              >
                <FaEnvelope className="btn-icon" />
                <span>CONTACT DEVIKA</span>
              </a>
              <a 
                href="https://www.xchip.in" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-secondary"
              >
                <FaGlobe className="btn-icon" />
                <span>WWW.XCHIP.IN</span>
              </a>
            </div>
            {/*
            <div className="social-links-grid">
              <a href="https://www.linkedin.com/in/manojkumarlinux/" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://x.com/manojkumarlinux/" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="Twitter / X">
                <FaXTwitter />
              </a>
              <a href="https://www.youtube.com/@manojkumarlinux" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="YouTube">
                <FaYoutube />
              </a>
              <a href="https://www.instagram.com/manojkumarlinux" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/manojkumar.net" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="Facebook">
                <FaFacebook />
              </a>
            </div>
            */}
          </div>
        </motion.div>
      </main>
    </div>
  );
}

export default Home;
